const zIndices = {
  modal: `101`
};

export default zIndices;
